export enum PrivacyLevel {
  PUBLIC = 'PUBLIC', // Accessible by anyone
  CONNECTION_ONLY = 'CONNECTION_ONLY', // Only accessible by connected users
}

export enum NoteEntityType {
  NOTE = 'NOTE',
  FEEDBACK = 'FEEDBACK',
}

export const MIN_NOTES_FOR_PERSONAL_SUMMARY = 5;
